import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'

import { default as AuthService } from '../services/Auth'
import SignInForm from './SignInForm'
import RoleContext, { USER_ROLE } from './RoleContext'
import { Routes } from '../App'
import LPContext, { DEFAULT_LP } from '../lpLoader/LPContext'
import Auth from '../services/Auth'

const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [mfa, setMfa] = useState<string | undefined>(undefined)
  const [rememberMe, setRememberMe] = useState(false)
  const [showMfa, setShowMfa] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const roleContext = useContext(RoleContext)
  const lpContext = useContext(LPContext)
  const history = useHistory()

  const doLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setError("");
    setLoading(true)
    const response = await AuthService.signIn(username, password, mfa, rememberMe)
    setLoading(false)

    if (response.is_error) {
      setError(
        response.error_content.error_description || response.error_content
      )
      if (response.resetMfa) {
        setMfa(undefined);
      }
    } else if (response.content.token == null && response.content.showMfa) {
      setShowMfa(true);
    } else {
      
      const token = response.content.token;

      if (token) {
        const roles = Auth.getRoles();

        if (Auth.checkRoleMembership([USER_ROLE.ADMIN, USER_ROLE.AGLC, USER_ROLE.DEFAULT])) {
          roleContext.setRoles(roles);
        }

        if (Auth.checkRoleMembership([USER_ROLE.DEFAULT])) {
          lpContext.setLP(Auth.getLP());
        } else {
          lpContext.setLP(DEFAULT_LP);
        }

          localStorage.setItem("PasswordChangeRequired", response.content.passwordChangeRequired);
      }

      history.push(Routes.Home)
    }
  }

  const resendCode = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event?.preventDefault();

    AuthService.resendCode(username, password).then((response) => {

      if (response.is_error) {
        setError(response.error_content.error_description || response.error_content);
      } else {
        setError('');
        alert('A new MFA code has been sent to you. Please check your inbox and enter the code to proceed with the login process.');
      }
    }).catch(() => {
      alert('An error occurred while resending the MFA code. Please try again later.');
    });

    return false;
  }

  return (
    <SignInForm
      username={username}
      password={password}
      mfa={mfa}
      rememberMe={rememberMe}
      handleUsername={setUsername}
      handlePassword={setPassword}
      handleMfa={setMfa}
      handleRememberMe={setRememberMe}
      showMfa={showMfa}
      handleSubmit={doLogin}
      error={error}
      submitting={loading}
      resendCode={resendCode }
    />
  )
}

export default Login
